import { useState } from "react";
import { Download, FileDown, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

const MSG_FALLA = "No se pudo abrir el documento. Intenta de nuevo o avisa a soporte.";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function mensajeFalla(e) {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try {
      const detalle = JSON.parse(await data.text())?.detail;
      if (typeof detalle === "string" && detalle) return detalle;
    } catch (_err) { /* cuerpo no JSON */ }
    return MSG_FALLA;
  }
  return apiError(e) || MSG_FALLA;
}

async function leer(docId) {
  const { data } = await api.post(`/documentos/${docId}/signed-url`);
  const blob = await api.get(data.url.replace(/^\/api/, ""), { responseType: "blob" }).then((r) => r.data);
  return { url: `${BACKEND_URL}${data.url}`, blob };
}

/** Ver / Descargar un documento del expediente (mismo enlace firmado que usa el Comité hoy). */
export function DocBotones({ docId, nombre, testid }) {
  const [busy, setBusy] = useState("");
  const ver = async () => {
    setBusy("ver");
    const pestana = window.open("", "_blank");
    try {
      const { url } = await leer(docId);
      if (pestana) pestana.location.replace(url); else window.open(url, "_blank", "noopener");
    } catch (e) { if (pestana) pestana.close(); toast.error(await mensajeFalla(e)); }
    finally { setBusy(""); }
  };
  const descargar = async () => {
    setBusy("descargar");
    try {
      const { blob } = await leer(docId);
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = nombre || "documento";
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    } catch (e) { toast.error(await mensajeFalla(e)); }
    finally { setBusy(""); }
  };
  return (
    <span className="ml-auto flex gap-1">
      <Button size="sm" variant="outline" className="h-7 px-2 text-xs" type="button" disabled={!!busy}
        onClick={ver} data-testid={`${testid}-ver`}>
        {busy === "ver" ? <Loader2 className="mr-1 h-3 w-3 animate-spin" /> : <FileDown className="mr-1 h-3 w-3" />} Ver
      </Button>
      <Button size="sm" variant="outline" className="h-7 px-2 text-xs" type="button" disabled={!!busy}
        onClick={descargar} data-testid={`${testid}-descargar`}>
        {busy === "descargar" ? <Loader2 className="mr-1 h-3 w-3 animate-spin" /> : <Download className="mr-1 h-3 w-3" />} Descargar
      </Button>
    </span>
  );
}
